"use client";
import { usePathname } from "next/navigation";
import { Button } from "../ui/button";
import { appendAttributionToUrl } from "@/lib/attribution";
import { CONVERSION_PAGE_PATH, scrollToSignupForm } from "@/lib/conversion-page";

const NavMenuBtn = () => {
  const isConversionPage = usePathname() === CONVERSION_PAGE_PATH;

  if (isConversionPage) {
    return (
      <Button radius="full" size="lg" onClick={scrollToSignupForm}>
        Sign up
      </Button>
    );
  }

  return (
    <Button
      radius="full"
      size="lg"
      onClick={() =>
        (window.location.href = appendAttributionToUrl(
          `${process.env.NEXT_PUBLIC_USER_APP}/sign-in`,
        ))
      }
    >
      Sign in
    </Button>
  );
};

export default NavMenuBtn;
